import { BarceloComponent } from "barcelo-components";

const GenericComponents = {
  cta: BarceloComponent({ selector: ".c-cta", path: "generic/cta/js/c-cta" }),
  socialSharing: BarceloComponent({ selector: ".c-social-sharing", path: "generic/social-sharing/js/social-sharing" }),
  filePicker: BarceloComponent({ selector: ".barcelo-filePicker", path: "generic/filePicker/js/filePicker" }),
};

export default GenericComponents;
